import React from "react";
import { useNavigate } from "react-router-dom";

const TeddyScreen = () => {
  const navigate = useNavigate();
  return (
    <section id="screen-teddy" className="screen">
      {/* Falling Petals Background */}
      <div className="teddy-background">
        <div className="petal" style={{ "--x": "10%", "--delay": "0s" }} />
        <div className="petal" style={{ "--x": "30%", "--delay": "1s" }} />
        <div className="petal" style={{ "--x": "50%", "--delay": "2s" }} />
        <div className="petal" style={{ "--x": "70%", "--delay": "0.5s" }} />
        <div className="petal" style={{ "--x": "90%", "--delay": "1.5s" }} />
      </div>

      <div className="teddy-content">
        <h1 className="teddy-title">For My Precious One 🧸🌹</h1>

        <div className="teddy-display">
          {/* Teddy Bear */}
          <div className="teddy-bear">
            <svg viewBox="0 0 200 250">
              <defs>
                <linearGradient id="furGrad" x1="0%" y1="0%" x2="0%" y2="100%">
                  <stop offset="0%" stopColor="#D2691E" />
                  <stop offset="100%" stopColor="#8B4513" />
                </linearGradient>
                <linearGradient
                  id="snoutGrad"
                  x1="0%"
                  y1="0%"
                  x2="0%"
                  y2="100%"
                >
                  <stop offset="0%" stopColor="#F4A460" />
                  <stop offset="100%" stopColor="#DEB887" />
                </linearGradient>
              </defs>

              {/* Ears */}
              <circle cx="55" cy="60" r="28" fill="url(#furGrad)" />
              <circle cx="55" cy="60" r="18" fill="#F4A460" />
              <circle cx="145" cy="60" r="28" fill="url(#furGrad)" />
              <circle cx="145" cy="60" r="18" fill="#F4A460" />

              {/* Head */}
              <ellipse cx="100" cy="100" rx="60" ry="55" fill="url(#furGrad)" />
              <ellipse
                cx="100"
                cy="115"
                rx="35"
                ry="28"
                fill="url(#snoutGrad)"
              />

              {/* Face */}
              <ellipse cx="100" cy="105" rx="12" ry="10" fill="#333" />
              <ellipse
                cx="97"
                cy="102"
                rx="3"
                ry="2"
                fill="white"
                opacity="0.5"
              />
              <path
                d="M92 118Q100 125 108 118"
                stroke="#333"
                strokeWidth="2.5"
                fill="none"
                strokeLinecap="round"
              />
              <path d="M100 115L100 122" stroke="#333" strokeWidth="2" />

              {/* Eyes */}
              <circle cx="75" cy="90" r="8" fill="#333" />
              <circle cx="125" cy="90" r="8" fill="#333" />
              <circle cx="77" cy="87" r="3" fill="white" />
              <circle cx="127" cy="87" r="3" fill="white" />

              {/* Cheeks */}
              <ellipse
                cx="60"
                cy="110"
                rx="10"
                ry="6"
                fill="#FFB6C1"
                opacity="0.6"
              />
              <ellipse
                cx="140"
                cy="110"
                rx="10"
                ry="6"
                fill="#FFB6C1"
                opacity="0.6"
              />

              {/* Body */}
              <ellipse cx="100" cy="185" rx="55" ry="50" fill="url(#furGrad)" />
              <ellipse cx="100" cy="185" rx="35" ry="30" fill="#F4A460" />

              {/* Bow */}
              <path d="M85 155L70 145L70 165Z" fill="#FF1493" />
              <path d="M115 155L130 145L130 165Z" fill="#FF1493" />
              <circle cx="100" cy="155" r="8" fill="#FF69B4" />

              {/* Arms */}
              <ellipse
                cx="45"
                cy="170"
                rx="20"
                ry="35"
                fill="url(#furGrad)"
                transform="rotate(-20 45 170)"
              />
              <ellipse
                cx="155"
                cy="170"
                rx="20"
                ry="35"
                fill="url(#furGrad)"
                transform="rotate(20 155 170)"
              />

              {/* Heart */}
              <text x="82" y="195" fontSize="35">
                ❤️
              </text>

              {/* Legs */}
              <ellipse cx="65" cy="230" rx="22" ry="18" fill="url(#furGrad)" />
              <ellipse cx="135" cy="230" rx="22" ry="18" fill="url(#furGrad)" />
              <ellipse cx="65" cy="230" rx="12" ry="10" fill="#F4A460" />
              <ellipse cx="135" cy="230" rx="12" ry="10" fill="#F4A460" />
            </svg>
          </div>

          {/* Rose Bouquet */}
          <div className="rose-bouquet">
            <svg viewBox="0 0 200 320">
              {/* <!-- Wrapper --> */}
              <defs>
                <linearGradient
                  id="wrapperGrad"
                  x1="0%"
                  y1="0%"
                  x2="0%"
                  y2="100%"
                >
                  <stop offset="0%" style={{ "stop-color": "#FFF8DC" }} />
                  <stop offset="100%" style={{ "stop-color": "#F5DEB3" }} />
                </linearGradient>
                <linearGradient
                  id="roseGrad1"
                  x1="0%"
                  y1="0%"
                  x2="100%"
                  y2="100%"
                >
                  <stop offset="0%" style={{ "stop-color": "#FF1493" }} />
                  <stop offset="50%" style={{ "stop-color": "#DC143C" }} />
                  <stop offset="100%" style={{ "stop-color": "#8B0000" }} />
                </linearGradient>
                <linearGradient
                  id="roseGrad2"
                  x1="0%"
                  y1="0%"
                  x2="100%"
                  y2="100%"
                >
                  <stop offset="0%" style={{ "stop-color": "#FF69B4" }} />
                  <stop offset="50%" style={{ "stop-color": "#FF1493" }} />
                  <stop offset="100%" style={{ "stop-color": "#C71585" }} />
                </linearGradient>
              </defs>

              {/* <!-- Main Wrapper --> */}
              <path
                d="M25 140Q15 230 35 300L165 300Q185 230 175 140Z"
                fill="url(#wrapperGrad)"
                stroke="#DEB887"
                stroke-width="2"
              />
              <path
                d="M25 140Q100 165 175 140"
                fill="#FAF0E6"
                stroke="#DEB887"
                stroke-width="2"
              />

              {/* <!-- Back Layer Roses (Pink) --> */}
              <g class="rose rose-back-1">
                <circle cx="55" cy="110" r="26" fill="url(#roseGrad2)" />
                <circle cx="55" cy="110" r="18" fill="#C71585" />
                <circle cx="55" cy="110" r="10" fill="#8B008B" />
              </g>
              <g class="rose rose-back-2">
                <circle cx="145" cy="110" r="26" fill="url(#roseGrad2)" />
                <circle cx="145" cy="110" r="18" fill="#C71585" />
                <circle cx="145" cy="110" r="10" fill="#8B008B" />
              </g>

              {/* <!-- Front Layer Roses (Red) --> */}
              <g class="rose rose-1">
                <circle cx="70" cy="95" r="30" fill="url(#roseGrad1)" />
                <circle cx="70" cy="95" r="22" fill="#B22222" />
                <circle cx="70" cy="95" r="14" fill="#8B0000" />
              </g>
              <g class="rose rose-2">
                <circle cx="100" cy="75" r="34" fill="url(#roseGrad1)" />
                <circle cx="100" cy="75" r="24" fill="#B22222" />
                <circle cx="100" cy="75" r="16" fill="#8B0000" />
              </g>
              <g class="rose rose-3">
                <circle cx="130" cy="95" r="30" fill="url(#roseGrad1)" />
                <circle cx="130" cy="95" r="22" fill="#B22222" />
                <circle cx="130" cy="95" r="14" fill="#8B0000" />
              </g>

              {/* <!-- Lower Roses --> */}
              <g class="rose rose-4">
                <circle cx="60" cy="135" r="27" fill="url(#roseGrad1)" />
                <circle cx="60" cy="135" r="19" fill="#B22222" />
                <circle cx="60" cy="135" r="11" fill="#8B0000" />
              </g>
              <g class="rose rose-5">
                <circle cx="100" cy="145" r="28" fill="url(#roseGrad2)" />
                <circle cx="100" cy="145" r="20" fill="#C71585" />
                <circle cx="100" cy="145" r="12" fill="#8B008B" />
              </g>
              <g class="rose rose-6">
                <circle cx="140" cy="135" r="27" fill="url(#roseGrad1)" />
                <circle cx="140" cy="135" r="19" fill="#B22222" />
                <circle cx="140" cy="135" r="11" fill="#8B0000" />
              </g>

              {/* <!-- Baby's Breath flowers (more) --> */}
              <g fill="white" opacity="0.9">
                <circle cx="45" cy="125" r="4" />
                <circle cx="52" cy="118" r="3" />
                <circle cx="40" cy="140" r="3.5" />
                <circle cx="150" cy="125" r="4" />
                <circle cx="158" cy="118" r="3" />
                <circle cx="155" cy="140" r="3.5" />
                <circle cx="65" cy="60" r="3" />
                <circle cx="135" cy="60" r="3" />
                <circle cx="100" cy="55" r="3.5" />
                <circle cx="85" cy="165" r="3" />
                <circle cx="115" cy="165" r="3" />
              </g>

              {/* <!-- Small decorative flowers --> */}
              <g>
                <circle cx="45" cy="155" r="8" fill="#FFB6C1" />
                <circle cx="45" cy="155" r="5" fill="#FF69B4" />
                <circle cx="155" cy="155" r="8" fill="#FFB6C1" />
                <circle cx="155" cy="155" r="5" fill="#FF69B4" />
              </g>

              {/* <!-- Green Leaves --> */}
              <g fill="#228B22">
                <ellipse
                  cx="40"
                  cy="170"
                  rx="14"
                  ry="26"
                  transform="rotate(-35 40 170)"
                />
                <ellipse
                  cx="160"
                  cy="170"
                  rx="14"
                  ry="26"
                  transform="rotate(35 160 170)"
                />
                <ellipse
                  cx="50"
                  cy="190"
                  rx="12"
                  ry="22"
                  transform="rotate(-50 50 190)"
                />
                <ellipse
                  cx="150"
                  cy="190"
                  rx="12"
                  ry="22"
                  transform="rotate(50 150 190)"
                />
                <ellipse
                  cx="30"
                  cy="150"
                  rx="10"
                  ry="18"
                  transform="rotate(-25 30 150)"
                />
                <ellipse
                  cx="170"
                  cy="150"
                  rx="10"
                  ry="18"
                  transform="rotate(25 170 150)"
                />
              </g>

              {/* <!-- Light green accent leaves --> */}
              <g fill="#32CD32" opacity="0.8">
                <ellipse
                  cx="45"
                  cy="205"
                  rx="10"
                  ry="18"
                  transform="rotate(-60 45 205)"
                />
                <ellipse
                  cx="155"
                  cy="205"
                  rx="10"
                  ry="18"
                  transform="rotate(60 155 205)"
                />
              </g>

              {/* <!-- Beautiful Ribbon --> */}
              <g>
                <path
                  d="M80 280Q100 320 120 280"
                  fill="#FF1493"
                  stroke="#C71585"
                  stroke-width="2"
                />
                <ellipse cx="100" cy="280" rx="22" ry="15" fill="#FF69B4" />
                {/* <!-- Ribbon tails --> */}
                <path
                  d="M78 278L60 295"
                  stroke="#FF1493"
                  stroke-width="4"
                  stroke-linecap="round"
                />
                <path
                  d="M122 278L140 295"
                  stroke="#FF1493"
                  stroke-width="4"
                  stroke-linecap="round"
                />
                {/* <!-- Ribbon shine --> */}
                <ellipse
                  cx="95"
                  cy="275"
                  rx="8"
                  ry="4"
                  fill="#FFB6C1"
                  opacity="0.6"
                />
              </g>

              {/* <!-- Sparkle decorations --> */}
              <g fill="#FFD700" opacity="0.8">
                <text x="35" y="85" font-size="10">
                  ✨
                </text>
                <text x="155" y="85" font-size="10">
                  ✨
                </text>
                <text x="100" y="45" font-size="12">
                  💖
                </text>
                <text x="70" y="180" font-size="8">
                  💕
                </text>
                <text x="125" y="180" font-size="8">
                  💕
                </text>
              </g>

              {/* <!-- Leaves --> */}
              <ellipse
                cx="45"
                cy="150"
                rx="12"
                ry="22"
                fill="#228B22"
                transform="rotate(-30 45 150)"
              />
              <ellipse
                cx="135"
                cy="150"
                rx="12"
                ry="22"
                fill="#228B22"
                transform="rotate(30 135 150)"
              />
              <ellipse
                cx="55"
                cy="165"
                rx="10"
                ry="18"
                fill="#32CD32"
                transform="rotate(-45 55 165)"
              />
              <ellipse
                cx="125"
                cy="165"
                rx="10"
                ry="18"
                fill="#32CD32"
                transform="rotate(45 125 165)"
              />
            </svg>
          </div>
        </div>

        {/* Love Messages */}
        <div className="love-messages">
          <div className="message-bubble bubble-1">
            <p>"You make my heart bloom like these roses"</p>
            <span className="bubble-hearts">🌹💕</span>
          </div>
          <div className="message-bubble bubble-2">
            <p>"As cuddly and warm as this teddy bear"</p>
            <span className="bubble-hearts">🧸💖</span>
          </div>
          <div className="message-bubble bubble-3">
            <p>"Forever & Always Yours"</p>
            <span className="bubble-hearts">💝✨</span>
          </div>
        </div>

        {/* Navigation */}
        <div className="nav-buttons">
          <button
            className="btn btn-back"
            data-back="success"
            onClick={() => navigate(-1)}
          >
            ← Back to Gifts
          </button>
          <button
            className="btn btn-next"
            data-next="letter"
            onClick={() => navigate("/chocolate")}
          >
            Next Gift →
          </button>
        </div>
      </div>
    </section>
  );
};

export default TeddyScreen;
